import { render, staticRenderFns } from "./Inventario.vue?vue&type=template&id=1b5ca31e&scoped=true&"
import script from "./Inventario.vue?vue&type=script&lang=js&"
export * from "./Inventario.vue?vue&type=script&lang=js&"
import style0 from "./Inventario.vue?vue&type=style&index=0&id=1b5ca31e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5ca31e",
  null
  
)

export default component.exports